export default "__VITE_ASSET__4d707570__"